import type { JC2Dealer } from '../siteServicesApi/jc2Schemas/jc2Dealer';

export const isApprovedDealer = (dealer: JC2Dealer) =>
  dealer.role === 4 || dealer.role === 18;

/**
 * https://jci-intrusion.atlassian.net/wiki/spaces/CLOUD/pages/28282516/Site+Device+Grouping#Role-Enum
 */
export const userRoles: { [key: string]: string } = {
  // Subdealers
  3: 'Dealer admin',
  4: 'Dealer admin',
  // Dealers
  17: 'Dealer admin',
  18: 'Dealer admin',
};
